export default {
  searchTitle: '検索結果',
  searchPlaceholder: '記事を検索...',
  searchButton: '検索',
  searchLoading: '検索中...',
  // 含 query 的副标题前缀：组件内拼接 query（如 "検索結果：tone"）
  searchResultsForPrefix: '検索結果：',
  searchEmptyTitle: '結果が見つかりません',
  // 含 query の空結果説明：コンポーネント内で prefix + query + suffix を結合
  searchEmptyQueryPrefix: '“',
  searchEmptyQuerySuffix: '”に一致する記事は見つかりませんでした。',
  searchResultCount: '{count} 件の結果',
};
